import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeProductManagement: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Product Management',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Product demo',
        },
        {
            label: 'Sales enablement',
        },
        {
            label: 'Customer onboarding',
        },
        {
            label: 'Customer training',
        },
        {
            label: 'Product update',
        },
        {
            label: 'Knowledge base',
        },
        {
            label: 'How-to guide',
        },
        {
            label: 'Employee onboarding',
        },
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'AI innovation',
        },
        {
            label: 'Other',
        },
    ],
};
